<script>
    /*
    	TaxonomyFieldsGroup.svelte

        Consists of <DataTaxonomyField> components

    */

    import { onMount } from 'svelte';
    import { TCARE_TAX_1, OPEN_ELIG_2022, DEMOGRAPHICS } from '../../common/taxonomy-classes.js';
    import { shallowArraysEqual } from '../../common/utils.js';
    

    // TCARE components
    import DataTaxonomyField from '../data-fields/DataTaxonomyField.svelte';
    import FieldGroupExpandBar from './FieldGroupExpandBar.svelte';
    import {VIRTUAL} from "../../common/taxonomy-classes";

    // SMUI components

    // const FIELDS = [TCARE_TAX_1, OPEN_ELIG_2022, DEMOGRAPHICS];
    const GROUP_TITLE = 'Keywords';

    export let store;                   // container of the taxonomies object (e.g. rightServiceStore)
    export let leftService;
    export let rightService;
    export let onCopyTaxonomy;
    export let isEditable;
    export let isOpen;
    export let showTcareTax1;
    export let showDiffs;       // bypass the strike-through and highlighting
    
    $: isExpanded = isOpen;

    onMount(() => {
        // console.log('');
        // console.log('TaxonomyFieldsGroup onMount');
    })

    const toggleIsExpanded = () => {
        isExpanded = !isExpanded;
    }

    const isTaxDiff = (taxName) => {
        let result = false;
        if (!leftService || !leftService.taxonomies) return false;
        if (!rightService || !rightService.taxonomies) return false;
        if (!leftService.taxonomies[taxName]) return false;
        if (!rightService.taxonomies[taxName]) return false;

        // we cannot do this because the orders may be different but same content!
        // return !shallowArraysEqual(leftService.taxonomies[taxName], rightService.taxonomies[taxName]);

        let lTax = leftService.taxonomies[taxName].sort();
        let rTax = rightService.taxonomies[taxName].sort();        
        result = !shallowArraysEqual(lTax, rTax);
        return result;
    }

</script>

<style>
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="field-group">
    
    <FieldGroupExpandBar title={GROUP_TITLE} {isExpanded} {toggleIsExpanded} />

    {#if isExpanded && store}
        <div class="fields-area">

            {#if showTcareTax1}
                <DataTaxonomyField
                    store={store}
                    taxName={TCARE_TAX_1}
                    label={'Service Category'}
                    isEditable={isEditable}
                    isOrigDiff={false}
                    isNewDiff={isTaxDiff(TCARE_TAX_1)}
                    onCopyTaxonomy={onCopyTaxonomy}
                    tooltip={''}
                    {showDiffs}
                />
            {/if}
                    
            <DataTaxonomyField
                store={store}
                taxName={OPEN_ELIG_2022}
                label={'Social Service Classification'}
                isEditable={isEditable}
                isOrigDiff={false}
                isNewDiff={isTaxDiff(OPEN_ELIG_2022)}
                onCopyTaxonomy={onCopyTaxonomy}
                tooltip={''}
                {showDiffs}
                />

            <DataTaxonomyField
                store={store}
                taxName={DEMOGRAPHICS}
                label={'Demographics Served'}
                isEditable={isEditable}
                isOrigDiff={false}
                isNewDiff={isTaxDiff(DEMOGRAPHICS)}
                onCopyTaxonomy={onCopyTaxonomy}
                tooltip={''}
                {showDiffs}
                />

            <DataTaxonomyField
                    store={store}
                    taxName={VIRTUAL}
                    label={'Coverage Areas'}
                    isEditable={isEditable}
                    isOrigDiff={false}
                    isNewDiff={isTaxDiff(VIRTUAL)}
                    onCopyTaxonomy={onCopyTaxonomy}
                    tooltip={''}
                    {showDiffs}
            />
            
        </div>
    {/if}
</div>
